package org.ecolution.webpage.data

data class FAQ(val question: String, val answer: String)